var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebooklogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook logo",
    clipPath: "url(#clip0_19_807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_b_19_807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 30C23.2843 30 30.0001 23.2843 30.0001 15C30.0001 6.71573 23.2843 0 15.0001 0C6.71579 0 6.10352e-05 6.71573 6.10352e-05 15C6.10352e-05 23.2843 6.71579 30 15.0001 30Z",
    fill: "#444444",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.1665 7.7998H15.8651C14.4994 7.7998 12.9803 8.37421 12.9803 10.3539C12.987 11.0437 12.9803 11.7043 12.9803 12.4478H11.4004V14.9619H13.0292V22.1998H16.0223V14.9142H17.9979L18.1766 12.4407H15.9707C15.9707 12.4407 15.9757 11.3404 15.9707 11.0209C15.9707 10.2386 16.7848 10.2834 16.8337 10.2834C17.2211 10.2834 17.9743 10.2845 18.1676 10.2834V7.7998H18.1665Z",
    fill: "#EDEDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_19_807",
    x: -1.19994,
    y: -1.2,
    width: 32.4,
    height: 32.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19_807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19_807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebooklogo);
export default __webpack_public_path__ + "static/media/Facebook logo.594f24f5838d151d55bab768fa9dbf49.svg";
export { ForwardRef as ReactComponent };